import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-center whitespace-normal text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--button-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--button-ring-offset)] cursor-pointer disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        primary:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        primaryMobile:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        primaryMobileB2B:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        secondaryAssist:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        secondarySubmit:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        secondarySubmitMobile:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        tertiaryCancel:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        tertiaryCancelIcon:
          'text-[var(--button-fg)] bg-transparent hover:bg-transparent active:bg-transparent',
        tertiaryMovement:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
        destructiveCancelRenewal:
          'border text-[var(--button-fg)] bg-[var(--button-bg)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-active)]',
      },
      size: {
        sm: 'min-h-8 px-3 py-2',
        md: 'min-h-10 px-4 py-3',
        lg: 'min-h-10 px-6 py-4',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
)
